import type { OpportunityFilters } from './useOpportunityFilters.types';

export const DEFAULT_FILTERS: OpportunityFilters = {
  targetAudiences: [],
} as const;
